import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { NexusFormResultModel } from 'app/core/models/nexus-form-result.model';
import { CustomerOptOutModel } from 'app/models/customer-opt-out.model';
import { NotificationCategoryModel } from 'app/models/notification-category.model';
import { NotificationSettingModel } from 'app/models/notification-setting.model';
import { NotificationsService } from 'app/services/notifications.service';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: false
})
export class NotificationsComponent extends NexusComponent implements OnInit {
public notification_setting_model: Array<NotificationSettingModel>;
public form_result: NexusFormResultModel = new NexusFormResultModel();

  constructor(private route: ActivatedRoute, private notifications_service: NotificationsService, private change_detect: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {

    this.route.data.subscribe(({ notification_setting_model }) => {
            this.notification_setting_model = notification_setting_model;
        });

        this.change_detect.detectChanges();
  }

  public update(customer_opt_out: CustomerOptOutModel) {
      this.form_result.Reset();
      this.StartSpinner();
      this.notifications_service.SaveNotificationSettings(customer_opt_out).subscribe(
        data => {
          this.form_result.Success();
          this.notification_setting_model = data;
          this.StopSpinner();
        },
        error => {
          this.form_result.Error(error);
          this.StopSpinner();
        });
    }

    optOutOfAll(notification_category: NotificationCategoryModel)
    {
      this.form_result.Reset();
      this.StartSpinner();
      this.notifications_service.OptOutOfAll(notification_category).subscribe(
        data => {
          this.form_result.Success();
          this.notification_setting_model = data;
          this.StopSpinner();
        },
        error => {
          this.form_result.Error(error);
          this.StopSpinner();
        });
    }

    requiredCheck(opt_out: CustomerOptOutModel)
    {
      let notification_setting : NotificationSettingModel = new NotificationSettingModel();
      const opt_outs : Array<CustomerOptOutModel> = new Array<CustomerOptOutModel>();

      notification_setting = this.notification_setting_model?.find(f => f.notification_category_id === opt_out.notification_category_id);

      if(notification_setting?.notification_category?.opt_out_allowed === false)
      {
        if(notification_setting?.email === false)
        {
          opt_outs.push(notification_setting?.email_opt_out);
        }
        if(notification_setting?.sms === false)
        {
          opt_outs.push(notification_setting?.sms_opt_out);
        }
        if(notification_setting?.phone === false)
        {
          opt_outs.push(notification_setting?.phone_opt_out);
        }
      }

      if(opt_outs.length > 1 && opt_out.id === '00000000-0000-0000-0000-000000000000')
      {
        return false;
      }
      else{
        return true;
      }
    }
}
